import { Fragment } from "react";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";

export default function CheckoutDeliverySingleOption({
  itemGroups,
  renderDeliveryItem,
}: {
  itemGroups: TicketItemGroupType[];
  renderDeliveryItem: (itemGroup: TicketItemGroupType) => React.ReactNode;
}) {
  if (!itemGroups.length) return null;

  return (
    <>
      {itemGroups.map((itemGroup) => {
        return (
          <Fragment key={itemGroup.id}>
            {renderDeliveryItem(itemGroup)}
          </Fragment>
        );
      })}
    </>
  );
}
